module.exports = __webpack_public_path__ + "d718d6e8765a8155debdf85cf9378ddb.pdf";